import * as Yup from "yup";
import { Formik } from "formik";
import { useState } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
// import { apiPost } from 'src/configs/globalFunctions'

import {
  Box,
  Link,
  Button,
  FormHelperText,
  TextField,
  CircularProgress,
  Typography,
  IconButton,
  InputAdornment,
  // Stack,
  // Container,
  // Checkbox,
  // Typography,
  // FormControlLabel,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useAuth from "src/hooks/useAuth";
import useRefMounted from "src/hooks/useRefMounted";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

const LoginJWT = () => {
  const { login } = useAuth();
  const isMountedRef = useRefMounted();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [searchParams] = useSearchParams();
  const prefilledEmail = searchParams.get("email") || "";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Formik
      initialValues={{
        email: prefilledEmail,
        password: "",
        // email: 'demo@example.com',
        // password: 'TokyoPass1@',
        // email: 'eduardo@youngarts.com.br',
        // password: 'criacao',
        terms: true,
        submit: null,
      }}
      enableReinitialize
      validationSchema={Yup.object().shape({
        email: Yup.string().email(t("O e-mail fornecido deve ser um endereço de e-mail válido")).max(255),
        // .required(t("O campo e-mail é obrigatório")),
        password: Yup.string().max(255).required(t("O campo de senha é obrigatório")),
        terms: Yup.boolean().oneOf([true], t("Você deve concordar com nossos termos e condições")),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          await login(values.email, values.password);
          if (isMountedRef.current) {
            setStatus({ success: true });
            setSubmitting(false);
          }
        } catch (err) {
          if (isMountedRef.current) {
            const raw = err?.submitResult?.data;
            let errObj = {};
            if (raw && typeof raw === 'object') {
              errObj = raw;
            } else if (typeof raw === 'string') {
              try { errObj = JSON.parse(raw); } catch (_) {}
            }
            if (errObj.email || errObj.password) {
              setErrors(errObj);
            } else if (typeof errObj.error === 'string' && errObj.error.toLowerCase().includes('bloqueada')) {
              enqueueSnackbar(t('Sua conta está bloqueada. Entre em contato com o suporte.'), {
                variant: 'error',
                autoHideDuration: 8000,
              });
            } else if (typeof errObj.error === 'string') {
              enqueueSnackbar(errObj.error, {
                variant: 'error',
                autoHideDuration: 8000,
              });
            } else {
              enqueueSnackbar(t('Não foi possível realizar o login. Verifique seus dados e tente novamente.'), {
                variant: 'error',
                autoHideDuration: 8000,
              });
            }
            setStatus({ success: false });
            setSubmitting(false);
          }
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.error ? (
            <Typography
              textAlign={"center"}
              bgcolor={"error.main"}
              color={"error.contrastText"}
              borderRadius={1}
              px={2}
              py={1}
              mb={1}
            >
              {errors.error}
            </Typography>
          ) : null}
          <TextField
            error={Boolean(touched.email && errors.email)}
            fullWidth
            margin="normal"
            autoFocus
            helperText={touched.email && errors.email}
            label={t("Email")}
            name="email"
            onBlur={handleBlur}
            onChange={handleChange}
            type="email"
            value={values.email}
            variant="outlined"
          />
          <TextField
            error={Boolean(touched.password && errors.password)}
            fullWidth
            margin="normal"
            helperText={touched.password && errors.password}
            label={t("Senha")}
            name="password"
            onBlur={handleBlur}
            onChange={handleChange}
            type={showPassword ? "text" : "password"}
            value={values.password}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? t("Ocultar senha") : t("Mostrar senha")}
                    onClick={() => setShowPassword((prev) => !prev)}
                    onMouseDown={(e) => e.preventDefault()}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Box alignItems="center" display={{ xs: "block", md: "flex" }} justifyContent="space-between">
            {/* <Box display={{ xs: 'block', md: 'flex' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.terms}
                    name="terms"
                    color="primary"
                    onChange={handleChange}
                  />
                }
                label={
                  <>
                    <Typography variant="body2">
                      {t('I accept the')}{' '}
                      <Link component="a" href="#">
                        {t('terms and conditions')}
                      </Link>
                      .
                    </Typography>
                  </>
                }
              />
            </Box> */}
            <Link component={RouterLink} to="/account/recover-password">
              <b>{t("Esqueceu a senha?")}</b>
            </Link>
          </Box>

          {Boolean(touched.terms && errors.terms) && <FormHelperText error>{errors.terms}</FormHelperText>}

          <Button
            sx={{
              mt: 3,
            }}
            color="primary"
            startIcon={isSubmitting ? <CircularProgress size="1rem" /> : null}
            disabled={isSubmitting}
            type="submit"
            fullWidth
            size="large"
            variant="contained"
          >
            {t("Entrar")}
          </Button>
        </form>
      )}
    </Formik>
  );
};

export default LoginJWT;
